import fetch from "./sessionFetch";
import {authHeaders, baseUrl, handleResponse} from "./apiUtils";

async function getEnrollments() {
  const response = await fetch(`${baseUrl}enrollments`, {
    headers: authHeaders(),
  });
  return handleResponse(response);
}

async function saveEnrollment(enrollment) {
  const response = await fetch(`${baseUrl}enrollments/${enrollment.id || ""}`, {
    method: enrollment.id ? "PUT" : "POST",
    headers: authHeaders({ "content-type": "application/json" }),
    body: JSON.stringify(enrollment),
  });
  return handleResponse(response);
}

async function activatePackageEnrollment(enrollmentId, command) {
  const response = await fetch(`${baseUrl}enrollments/${enrollmentId}/package-activation`, {
    method: "POST",
    headers: authHeaders({ "content-type": "application/json" }),
    body: JSON.stringify(command),
  });
  return handleResponse(response);
}

async function extendPackageValidity(enrollmentId, command) {
  const response = await fetch(`${baseUrl}enrollments/${enrollmentId}/package-validity-extension`, {
    method: "POST",
    headers: authHeaders({ "content-type": "application/json" }),
    body: JSON.stringify(command),
  });
  return handleResponse(response);
}

export default {
  activatePackageEnrollment,
  extendPackageValidity,
  getEnrollments,
  saveEnrollment,
};
